// extracted by mini-css-extract-plugin
export default {"root":"EventsGroup_root__bnAeU","events":"EventsGroup_events__f0WHQ"};